import {useRef} from 'react'
import {getAnonymousId} from 'modules/meta/selectors'
import {useRouter} from 'next/router'
// eslint-disable-next-line no-restricted-imports
import {getExperimentSegmentationAttributes} from 'utils/server/getExperimentSegmentationAttributes'

import {defaultBrand} from '@vio/core/src/brand/config'

import type {RootState} from 'store'
import type {AllPageProps} from 'types/PageProps'
import type {Toggle} from 'types/Toggle'

/**
 * Create and memoize a toggle function to use during server-render.
 */
export const useCreateServerToggle = ({
  preloadedState,
  pageProps
}: {
  preloadedState: RootState
  pageProps: AllPageProps
}): Toggle | undefined => {
  const toggleRef = useRef<Toggle>()
  const router = useRouter()

  if (typeof window === 'undefined' && !toggleRef.current) {
    const {createServerToggle} =
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      require('@vio/core/src/_web/experiments/createServerToggle')
    const brand = pageProps.brand ?? defaultBrand
    const anonymousId = getAnonymousId(preloadedState)
    const urlObject = new URL(router.asPath, brand.siteAddresses.address)
    const attributes = getExperimentSegmentationAttributes(
      preloadedState,
      urlObject
    )
    toggleRef.current = createServerToggle(
      anonymousId,
      attributes,
      pageProps.experiments ?? {}
    )
  }

  return toggleRef.current
}
